<div class="bulk-upload-preview" *ngIf="viewState$ | async as view">
  <div class="bulk-upload-preview__container">
    <div class="bulk-upload-preview__top-bar" *ngIf="view.totalSelectableCount">
      <p class="bulk-upload-preview__top-bar-text" *ngIf="view.files.length === 1">
        {{

          '{{selectedPages}}
        of {{ totalPages }} selected across 1 file' | translate: { selectedPages:
        view.selectedCount, totalPages: view.totalSelectableCount} }}
      </p>
      <p class="bulk-upload-preview__top-bar-text" *ngIf="view.files.length > 1">
        {{
          '{{selectedPages}}
        of {{ totalPages }} selected across {{ totalFiles }} files' | translate: { selectedPages:
        view.selectedCount, totalPages: view.totalSelectableCount, totalFiles: view.files.length }
        }}
      </p>
      <div class="bulk-upload-preview__top-bar-spacer"></div>
      <app-pencil-button
        class="pencil-button small rounded light bulk-upload-preview__top-bar-button"
        [label]="'Select All' | translate"
        [disabled]="view.selectedCount === view.totalSelectableCount"
        (clickEvent)="selectAll()"
      >
      </app-pencil-button>
      <div class="bulk-upload-preview__top-bar-gap"></div>
      <app-pencil-button
        class="pencil-button small light bulk-upload-preview__top-bar-button"
        [label]="'Deselect All' | translate"
        [disabled]="view.selectedCount === 0"
        (clickEvent)="deselectAll()"
      >
      </app-pencil-button>
    </div>

    <div class="bulk-upload-preview__file" *ngFor="let file of view.files; trackBy: trackByFileId">
      <div class="bulk-upload-preview__header--collapsible" (click)="toggleCollapse(file.id)">
        <div class="bulk-upload-preview__title">
          <span class="bulk-upload-preview__title__filename">
            {{ file.name }}
          </span>
          <span class="bulk-upload-preview__title__pages">
            ({{ file.selectedCount }} {{ 'of' | translate }} {{ file.totalCount }})
          </span>
        </div>
        <div class="bulk-upload-preview__meta">
          <app-pencil-icon
            class="bulk-upload-preview__collapse-icon"
            [name]="file.isCollapsed ? 'expand_more' : 'expand_less'"
            [type]="IconTypes.materialIcon"
          >
          </app-pencil-icon>
        </div>
      </div>

      <div class="bulk-upload-preview__pdf-body" *ngIf="!file.isCollapsed">
        <div class="bulk-upload-preview__pdf-selector">
          <app-bulk-upload-pdf-preview-selector
            [pageItems]="file.pageItems"
            (pageSelectionChange)="
              handlePageSelectionChange(file.id, $event.index, $event.isSelected)
            "
          >
          </app-bulk-upload-pdf-preview-selector>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="failedFileNames$ | async as failedFileNames">
    <div class="bulk-upload-preview__error" *ngIf="failedFileNames.length">
      <app-pencil-icon
        class="bulk-upload-preview__error-icon"
        [name]="'cancel'"
        [type]="IconTypes.materialIcon"
        [outlined]="true"
      >
      </app-pencil-icon>
      <p class="bulk-upload-preview__error-text">
        <span class="bulk-upload-preview__error-text__title">
          {{
          '{{count}}
          files could not be processed:' | translate: { count: failedFileNames.length } }}
        </span>
        {{ failedFileNames.join(', ') }}
      </p>
    </div>
  </ng-container>
</div>
